/**
 * Membership-based name/contact masking utilities.
 * Protects company identities to drive subscription upgrades.
 */

const PAID_TIERS = ['silver', 'gold', 'vip'];

export const isPaidUser = (user) => {
  if (!user) return false;
  return PAID_TIERS.includes(user.membership);
};

/**
 * Mask a buyer name. Buyers are ALWAYS hidden to protect lead value.
 * Shows "Buyer from [country]" instead.
 */
export const maskBuyerName = (name, country) => {
  return `Buyer from ${country || 'International'}`;
};

/**
 * Mask supplier contact name for free/unauth users.
 * Supplier company names on listings remain visible (they want visibility).
 * But detailed contact info is locked.
 */
export const maskSupplierContact = (name, user) => {
  if (isPaidUser(user)) return name;
  if (!name) return '***';
  return name.substring(0, 3) + '***';
};

/**
 * Check if contact details should be locked
 */
export const isContactLocked = (user) => {
  return !isPaidUser(user);
};
